const PLACES_TOKEN = 'AIzaSyCLcCBd6iK37JUMngt6Z7ZM6zUdh7Gq9oY';

export { PLACES_TOKEN };
